import React from 'react'
import { BackpackIcon } from '@repo/ui'
import { useSoundEffect } from 'src/hooks/useSoundEffect'
import { FloatingButtonCircles } from 'src/components/FloatingButtonCircles'
import { useClientSideTranslation } from 'src/services/i18n'
import { useGetCurrentLanguage } from 'src/store/game'
import { useInventoryItemCount } from '../../store'
import { inventoryButtonVariants } from './InventoryButton.variants'

type InventoryButtonProps = Readonly<{
  isActive?: boolean
  onClick: () => void
  variant?: 'default' | 'right'
}>

export function InventoryButton({ isActive = false, onClick, variant = 'default' }: InventoryButtonProps) {
  const { playEffect } = useSoundEffect()
  const { t } = useClientSideTranslation(useGetCurrentLanguage())
  const itemCount = useInventoryItemCount()

  const handleClick = () => {
    playEffect('click')
    onClick()
  }

  const label = itemCount === 1 
    ? t('{{count}} item', { count: itemCount })
    : t('{{count}} items', { count: itemCount })

  const circlesPosition = variant === 'right' ? 'right' : 'left'
  const circlesVariant = isActive ? 'yellow' : 'default'

  return (
    <button className={inventoryButtonVariants({ isActive, variant })} onClick={handleClick} type="button">
      <span className="icon">
        <BackpackIcon />
      </span>
      <span className="label">{label}</span>
      <FloatingButtonCircles position={circlesPosition} variant={circlesVariant} />
    </button>
  )
}